import { Paper, styled, ToggleButton, ToggleButtonGroup, toggleButtonGroupClasses, ToggleButtonGroupProps, ToggleButtonProps } from '@mui/material'
import { memo, MouseEvent, ReactNode, useCallback } from 'react'
import { NonInteractiveTooltip } from '../custom'

export type GenericTabsProps<T> = Omit<ToggleButtonGroupProps, 'onChange'> & {
    value: T
    items: Array<{ key: T; label: string | JSX.Element; disabled?: boolean; tooltip?: ReactNode }>
    onChange: (value: T) => void
    tabProps?: Partial<ToggleButtonProps>
}
const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
    [`& .${toggleButtonGroupClasses.grouped}`]: {
        border: "none !important",
        maxHeight: 27.1,
        [`&.${toggleButtonGroupClasses.disabled}`]: {
            border: 0
        }
    },
    [`& .${toggleButtonGroupClasses.middleButton},& .${toggleButtonGroupClasses.lastButton}`]: {
        marginLeft: -1,
        borderLeft: '1px solid transparent'
    }
}))

function renderToggleButton(item: any, tabProps: any, value: any) {
    const customTabProps = tabProps ? tabProps : {}
    if (item.tooltip) {
        return (
            <NonInteractiveTooltip title={item.tooltip} arrow={true} placement="bottom" key={item.key + (item.tooltip ? 1 : 2)}>
                <div>
                    <ToggleButton style={{ height: '100%' }} value={item.key} disabled={item.disabled} {...customTabProps}>
                        {item.label}
                    </ToggleButton>
                </div>
            </NonInteractiveTooltip>
        )
    } else {
        return (
            <ToggleButton value={item.key} key={item.key + (item.tooltip ? 1 : 2)} disabled={item.disabled} {...customTabProps} data-event={`${item.key} Tab Clicked`} style={{ minWidth: 30 }}>
                {item.label}
            </ToggleButton>
        )
    }
}

function GenericTabsSmall<T extends {}>({ value, items, onChange, tabProps, sx }: GenericTabsProps<T>) {
    const changeHandler = useCallback(
        (e: MouseEvent<HTMLElement>, val: T) => {
            onChange(val)
        },
        [onChange]
    )

    return (
        <Paper
            elevation={0}
            sx={{
                display: 'flex',
                border: (theme) => `1px solid ${theme.palette.divider}`,
                flexWrap: 'wrap',
                height: 28,
                ...sx
            }}
        >
            <StyledToggleButtonGroup id={'screener-view-type'} size="small" value={value} exclusive onChange={changeHandler} aria-label="text alignment" sx={{ width: '100%' }}>
                {items.map((item, i) => renderToggleButton(item, tabProps, value))}
            </StyledToggleButtonGroup>
        </Paper>
    )
}

export default memo(GenericTabsSmall) as typeof GenericTabsSmall
